import CirclesBg from "@assets/icons/circles-bg-invite-your-pt.svg";
import styled from "@emotion/styled";
import { AppLogo } from "@ui/components/common/app-logo";
import { physioMeMobileBreakpoint, physioMeTabletBreakpoint } from "@ui/style";
import { colors } from "@ui/style/colors";
import { svgComponentToCSS } from "@utils/svg-utils";
import React from "react";

const CONTENT_PADDING = 40;
const LOGO_HEIGHT = 65;

interface ProspectPageProps {
	backgroundColor: string;
	children: React.ReactNode;
}

export const ProspectPage = ({ backgroundColor, children }: ProspectPageProps): JSX.Element => (
	<Background backgroundColor={backgroundColor}>
		<PageContainer>
			<AppLogo width={242} height={LOGO_HEIGHT} color={colors.white} type="monochrome" />
			<ContentContainer>
				<InnerContentContainer>{children}</InnerContentContainer>
			</ContentContainer>
		</PageContainer>
	</Background>
);

const Background = styled.div<{ backgroundColor: string }>`
	min-height: 100vh;
	width: 100%;
	background-color: ${({ backgroundColor }) => backgroundColor};
	background-image: ${svgComponentToCSS(<CirclesBg color={colors.white} />)};
	background-repeat: no-repeat;
	background-position: bottom left;
	background-size: 100% auto;
	padding: 40px;

	@media ${physioMeTabletBreakpoint} {
		padding: 0px;
		padding-top: 40px;
		background-position: top left;
	}
`;

const PageContainer = styled.div`
	display: grid;
	place-items: center;
	place-content: center;
	gap: ${CONTENT_PADDING}px;
	overflow-x: hidden;
`;

const ContentContainer = styled.div`
	background-color: ${colors.white};
	display: grid;
	justify-content: center;
	border-radius: 16px;
	width: 1080px;
	max-width: calc(100vw - ${CONTENT_PADDING * 2}px);

	@media ${physioMeTabletBreakpoint} {
		width: 100vw;
		max-width: unset;
		border-radius: unset;
		min-height: calc(100vh - ${CONTENT_PADDING * 2 + LOGO_HEIGHT}px);
	}
`;

const InnerContentContainer = styled.div`
	display: grid;
	padding: 40px 80px;

	@media ${physioMeTabletBreakpoint} {
		max-width: 688px;
	}

	@media ${physioMeMobileBreakpoint} {
		max-width: 100%;
		padding: 40px 16px;
	}
`;
